import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Actions */
import { setCVProfile, updateCVProfile } from "../../../../redux/actions/admin";
import { setAlert } from "../../../../redux/actions/misc";

/* API requests */
import { getUserData, adminSignInAs } from "../../../../api-requests/user";
import { verifyReference } from "../../../../api-requests/candidate";

/* Components */
import OnlineCV from "../../../DashboardCandidate/components/CV/components/OnlineCV";
import DashboardSectionBase from "../../../../components/DashboardSectionBase";
import ConfirmModal from "../../../../components/ConfirmModal";
import { updateCandidate } from "../../../../api-requests/candidate";

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSignInAsConfirm: false,
            isSigningIn: false,
        };
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);

        if (this.props.match.params.id) {
            return getUserData(this.props.match.params.id)
                .then(user => this.props.setCVProfile(user));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.props.setCVProfile(null);
            const dash = document.getElementById("Dashboard");
            if (dash && dash.scrollTo) dash.scrollTo(0, 0);
            return getUserData(this.props.match.params.id)
                .then(user => this.props.setCVProfile(user));
        }
    }

    componentWillUnmount() {
        return this.props.setCVProfile(null);
    }

    requestSignInAs = () => this.setState({ showSignInAsConfirm: true });

    cancelSignInAs = () => {
        if (this.state.isSigningIn) return;
        this.setState({ showSignInAsConfirm: false });
    };

    confirmSignInAs = () => {
        const candidate = this.props.admin.cvProfile;
        if (!candidate?._id || this.state.isSigningIn) return;
        this.setState({ isSigningIn: true });
        return adminSignInAs(candidate._id)
            .then(result => {
                if (!result?.success) {
                    this.setState({ isSigningIn: false, showSignInAsConfirm: false });
                    this.props.setAlert("Couldn't switch session.", "error", true);
                    setTimeout(() => this.props.setAlert("Couldn't switch session.", "error", false), 2700);
                    return;
                }
                // Hard reload so all redux/session state is rebuilt fresh as
                // the candidate. The impersonation banner will render based
                // on the new session response.
                window.location.assign("/");
            });
    };

    saveCandidateNotes = (_id, value) => {
        return updateCandidate(_id, [{ propName: "notes", value: value }])
            .then(_ => {
                this.props.setAlert("Candidate notes updated!", "success", true);
                return setTimeout(() => this.props.setAlert("Candidate notes updated!", "success", false), 2700);
            });
    }

    verifyReference = (profile, reference) => {
        if ((reference.referenceName && reference.companyName && reference.position && reference.email) && (reference.referenceName !== "-" && reference.companyName !== "-" && reference.position !== "-" && reference.email !== "-")) {
            return verifyReference(profile._id, reference.email)
                .then(_ => getUserData(this.props.match.params.id).then(user => this.props.setCVProfile(user)));
        }
        return alert("In order to verify reference, reference name, company name, position and email are required. Please make sure the information is correct.");
    }

    render() {

        const candidate = this.props.admin.cvProfile;
        const fullName = candidate ? `${candidate.firstName || ""} ${candidate.lastName || ""}`.trim() : "";

        return(
            <div className="admin-page">
                {fullName &&
                    <header className="admin-page-header">
                        <div className="admin-page-header-titles">
                            <h1 className="admin-page-title">{fullName}</h1>
                            <p className="admin-page-subtitle">Candidate profile review.</p>
                        </div>
                        {candidate?._id &&
                            <button
                                type="button"
                                className="admin-page-action admin-page-action--ghost"
                                onClick={this.requestSignInAs}
                            >
                                Sign in as candidate
                            </button>
                        }
                    </header>
                }

                <div className="admin-cv-container">
                    <OnlineCV user={candidate} admin={true} verifyReference={this.verifyReference} />
                </div>

                <DashboardSectionBase title={"Candidate notes"} description={"Anything relevant about this candidate. Visible only to admins."}>
                    <textarea
                        className="admin-notes-textarea"
                        placeholder={"Add a note..."}
                        value={candidate?.profile?.notes || ""}
                        onChange={(e) => this.props.updateCVProfile([{ propName: "notes", value: e.target.value }])}
                    />
                    <div className="admin-notes-actions">
                        <button
                            type="button"
                            className="admin-page-action admin-page-action--primary"
                            onClick={() => candidate?.profile && this.saveCandidateNotes(candidate.profile._id, candidate.profile.notes)}
                        >
                            Save notes
                        </button>
                    </div>
                </DashboardSectionBase>

                <ConfirmModal
                    show={this.state.showSignInAsConfirm}
                    title={fullName ? `Sign in as ${fullName}?` : "Sign in as this candidate?"}
                    description={"You'll be switched into this candidate's account. Your admin session is paused — return to it any time using the banner at the top of the screen. Every sign-in is logged."}
                    confirmLabel={this.state.isSigningIn ? "Switching…" : "Sign in as candidate"}
                    cancelLabel={"Cancel"}
                    busy={this.state.isSigningIn}
                    onConfirm={this.confirmSignInAs}
                    onCancel={this.cancelSignInAs}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setCVProfile, updateCVProfile, setAlert }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
